import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Image from '../../../../Core/Image';
import ptsBubbleBlack from '../../../../../images/PTS-bubble-black.svg';
import Ctas from '../../../../Core/Ctas';

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.8rem 3.25rem 0.4rem;
  text-align: center;
  border-radius: 1.25rem;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  width: fit-content;
  margin: auto;
  margin-bottom: 3.8rem;
  border-radius: 1.125rem;
  border: 1px solid ${themeGet('colors.border-grey')};
`;

export const Button = styled.button`
  border-radius: 1.125rem;
  padding: 0.2rem 1.25em;
  min-width: 90px;
  &.active {
    background-color: ${themeGet('colors.secondary-velvet')};
    color: ${themeGet('colors.white')};
  }
`;

export const PointsContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  margin-bottom: 1.8rem;

  &.points-breakdown {
    > div:first-child {
      &::after {
        content: '+';
        display: block;
        margin: 0.75rem;
      }
    }
  }
`;

export const PointsBlock = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Points = styled.span``;

export const PointsWrapper = styled.div``;

export const EstimatedPoints = styled.span`
  font-size: 2rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 2.6rem;
  &::after {
    content: '';
    display: inline-block;
    background-image: url(${ptsBubbleBlack});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    height: 1rem;
    width: 1rem;
    margin-left: 0.25rem;
    margin-bottom: 0.625rem;
  }
`;

export const EstimatedWorth = styled.span`
  font-size: 2rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 2.6rem;
  color: ${themeGet('colors.secondary-velvet')};
`;

export const EstimatedWorthText = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

export const StyledImage = styled(Image)`
  width: 4.15rem;
  height: 4.35rem;
  flex-shrink: 0;
`;

export const StyledCtas = styled(Ctas)`
  margin-left: auto;
  margin-right: 0;

  button {
    text-decoration: underline;

    &::after {
      display: none;
    }
  }
`;
